import { InfoIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Heading,
  HStack,
  PinInput,
  PinInputField,
  Text,
  useToast,
  Container,
  VStack,
  Badge,
  Icon,
} from "@chakra-ui/react";
import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CartContext } from "../Context/CartContext";
import { FiShield, FiLock, FiCheckCircle } from "react-icons/fi";

function OtpPgae() {
  const [realOtp, setRealOtp] = useState('');
  const [state, setState] = useState();
  const [forwardCongo, setForwardCongo] = useState(false);

  const { cartData, SetCartData, getData, setOrderpageData, orderpageData } = useContext(CartContext);
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    const value = Math.floor(Math.random() * 9000 + 1000).toString();
    setState(value);

    toast({
      position: 'top',
      duration: 8000,
      isClosable: true,
      render: () => (
        <Box color='white' p={4} bg='#162237' borderRadius="xl" boxShadow="lg" border="1px solid rgba(234, 179, 8, 0.4)">
          <HStack spacing={3}>
            <Icon as={FiShield} color="#FACC15" boxSize={5} />
            <Box>
              <Text fontWeight="bold" fontSize="xs" textTransform="uppercase" color="#FACC15">
                Chamber Security Code
              </Text>
              <Text fontSize="sm">
                Your verification OTP is <strong style={{ fontSize: '16px', letterSpacing: '2px', color: '#FACC15' }}>{value}</strong>
              </Text>
            </Box>
          </HStack>
        </Box>
      ),
    });
  }, []);

  const orderPageProducts = () => {
    if (cartData && setOrderpageData && orderpageData) {
      setOrderpageData([...orderpageData, ...cartData]);
    }

    if (cartData && cartData.length > 0) {
      for (let i = 0; i < cartData.length; i++) {
        fetch(`https://flipkart-data-h5tg.onrender.com/products/${cartData[i].id}`, {
          method: "DELETE"
        })
          .then((response) => response.json())
          .then(() => {
            if (getData) getData();
          })
          .catch(() => {});
      }
    }
  };

  const handelgetOtp = (value) => {
    setRealOtp(value);
  };

  const handelSubmitOtp = () => {
    if (realOtp === state || (realOtp && realOtp.length === 4 && realOtp == state)) {
      navigate('/congo');
      setForwardCongo(true);
      orderPageProducts();
    } else {
      setRealOtp("");
      toast({
        position: 'top',
        status: 'error',
        title: 'Invalid OTP',
        description: 'The verification code entered does not match. Please verify and retry.',
        isClosable: true,
      });
    }
  };

  return (
    <Box
      minH="85vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="#F8FAFC"
      py={{ base: 8, md: 16 }}
      px={4}
    >
      <Container maxW="md">
        <Box
          bg="white"
          borderRadius="2xl"
          p={{ base: 6, md: 8 }}
          boxShadow="sm"
          border="1px solid"
          borderColor="gray.100"
          textAlign="center"
        >
          <Box
            w="64px"
            h="64px"
            mx="auto"
            mb={4}
            borderRadius="full"
            bg="blue.50"
            color="#162237"
            display="flex"
            alignItems="center"
            justifyContent="center"
            boxShadow="0 0 0 8px rgba(22, 34, 55, 0.05)"
          >
            <Icon as={FiLock} boxSize={7} />
          </Box>

          <Badge
            bg="rgba(234, 179, 8, 0.15)"
            color="#B45309"
            px={3}
            py={0.5}
            borderRadius="full"
            fontSize="xs"
            fontWeight="bold"
            letterSpacing="wider"
            textTransform="uppercase"
            mb={2}
          >
            Two-Factor Authorization
          </Badge>

          <Heading size="md" color="#162237" mb={2}>
            Enter Security Code
          </Heading>
          <Text fontSize="xs" color="gray.500" mb={6}>
            Please enter the 4-digit verification code sent to your registered mobile number and chamber email.
          </Text>

          <VStack spacing={6}>
            <HStack justify="center" spacing={3}>
              <PinInput
                size="lg"
                otp
                value={realOtp}
                onChange={handelgetOtp}
                onComplete={handelgetOtp}
                focusBorderColor="#162237"
              >
                <PinInputField borderRadius="xl" fontSize="xl" fontWeight="bold" textAlign="center" />
                <PinInputField borderRadius="xl" fontSize="xl" fontWeight="bold" textAlign="center" />
                <PinInputField borderRadius="xl" fontSize="xl" fontWeight="bold" textAlign="center" />
                <PinInputField borderRadius="xl" fontSize="xl" fontWeight="bold" textAlign="center" />
              </PinInput>
            </HStack>

            <Button
              w="full"
              size="lg"
              height="52px"
              bg="#162237"
              color="white"
              borderRadius="xl"
              fontWeight="bold"
              fontSize="sm"
              onClick={handelSubmitOtp}
              _hover={{ bg: "#0B132B", transform: "translateY(-1px)", boxShadow: "md" }}
              _active={{ bg: "#0B132B" }}
              transition="all 0.2s"
            >
              Verify & Complete Order
            </Button>

            <Text fontSize="xs" color="gray.400">
              Secured by 256-Bit SSL Judicial Payment Protocol
            </Text>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
}

export default OtpPgae;
